var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#2F5FE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3388 9.66648L27.3388 9.66648C26.6229 8.95052 25.4621 8.95052 24.7461 9.66648L9.66117 24.7514C8.94521 25.4674 8.94521 26.6282 9.66118 27.3442C10.3771 28.0601 11.5379 28.0601 12.2539 27.3442L27.3388 12.2592C28.0548 11.5432 28.0548 10.3824 27.3388 9.66648Z",
    fill: "#101010",
    stroke: "#2F5FE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3386 27.3437L27.3386 27.3437C28.0546 26.6278 28.0546 25.467 27.3386 24.751L12.2537 9.66605C11.5377 8.95009 10.3769 8.95009 9.66097 9.66606C8.94501 10.382 8.94501 11.5428 9.66097 12.2588L24.7459 27.3437C25.4619 28.0597 26.6227 28.0597 27.3386 27.3437Z",
    fill: "#101010",
    stroke: "#2F5FE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.927e5dd2e244d97c0861db7f8fbf680f.svg";
export { ForwardRef as ReactComponent };